module.exports = __webpack_public_path__ + "img/banner.aa328202.png";